export const ConvertRGB = (hex: string | undefined): string | void => {
  if (!hex) return
  const x = hex.replace('#', '')
  const r = parseInt(x.substring(0, 2), 16)
  const g = parseInt(x.substring(2, 4), 16)
  const b = parseInt(x.substring(4, 6), 16)
  const result = `${r},${g},${b}`
  return result
}

export const LightenDarkenColor = (col: string | undefined, amt: number): string | void => {
  if (!col) return
  let usePound = false
  if (col[0] === '#') {
    col = col.slice(1)
    usePound = true
  }
  const num = parseInt(col, 16)
  let r = (num >> 16) + amt
  if (r > 255) r = 255
  else if (r < 0) r = 0
  let b = ((num >> 8) & 0x00ff) + amt
  if (b > 255) b = 255
  else if (b < 0) b = 0
  let g = (num & 0x0000ff) + amt
  if (g > 255) g = 255
  else if (g < 0) g = 0
  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
}

export const CheckDarkMode = (color: string | undefined): number | void => {
  if (!color) return
  const x = color.replace('#', '')
  const r = parseInt(x.substring(0, 2), 16)
  const g = parseInt(x.substring(2, 4), 16)
  const b = parseInt(x.substring(4, 6), 16)
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))
  return hsp
}

export const mixColor = function (color_1: string, color_2: string, weight: number) {
  color_1 = color_1.replace('#', '')
  color_2 = color_2.replace('#', '')
  function d2h(d: number) {
    return d.toString(16)
  } // convert a decimal value to hex
  function h2d(h: string) {
    return parseInt(h, 16)
  } // convert a hex value to decimal

  weight = typeof weight !== 'undefined' ? weight : 50 // set the weight to 50%, if that argument is omitted

  let color = '#'

  for (let i = 0; i <= 5; i += 2) {
    // loop through each of the 3 hex pairs—red, green, and blue
    const v1 = h2d(color_1.substr(i, 2)) // extract the current pairs
    const v2 = h2d(color_2.substr(i, 2))
    // combine the current pairs from each source color, according to the specified weight
    let val = d2h(Math.floor(v2 + (v1 - v2) * (weight / 100.0)))

    while (val.length < 2) {
      val = '0' + val
    } // prepend a '0' if val results in a single digit

    color += val // concatenate val to our new color string
  }

  return color // PROFIT!
}

export const colorOpacity = function (hex: string, opacity: number) {
  const x = hex.replace('#', '')
  const r = parseInt(x.substring(0, 2), 16)
  const g = parseInt(x.substring(2, 4), 16)
  const b = parseInt(x.substring(4, 6), 16)
  return `rgba(${r},${g},${b}, ${opacity})`
}

export function lightOrDark(color: string): 'dark' | 'light' {
  // Variables for red, green, blue values
  let r, g, b

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    const color1 = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)

    // @ts-ignore
    r = color1[1]
    // @ts-ignore
    g = color1[2]
    // @ts-ignore
    b = color1[3]
  } else {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    // @ts-ignore
    const color1 = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'))

    r = color1 >> 16
    g = (color1 >> 8) & 255
    b = color1 & 255
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  // @ts-ignore
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return 'light'
  } else {
    return 'dark'
  }
}
